import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {Farm} from 'src/app/infrastructure/moovement-api/models/farm';
import {WeatherResponse} from 'src/app/presentation/common/weather-widget/weather-response';
import {PaddockGeometry} from 'src/app/infrastructure/moovement-api/models/asset';

interface FarmState {
  area: number | undefined;
  farm: Farm | undefined;
  loading: boolean;
  paddockGeometries: Map<string, PaddockGeometry>;
  weather: WeatherResponse | undefined;
}

const initialState: FarmState = {
  area: undefined,
  farm: undefined,
  loading: true,
  paddockGeometries: new Map<string, PaddockGeometry>(),
  weather: undefined
};

export const FarmStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    reset() {
      patchState(store, initialState);
    },
    setFarm(farm: Farm) {
      patchState(store, {farm, loading: false});
    },
    setPaddockGeometries(geometries: PaddockGeometry[]) {
      let area = 0;
      const paddockGeometries = new Map<string, PaddockGeometry>();
      geometries.forEach(geometry => {
        area += geometry.area;
        paddockGeometries.set(geometry.id, geometry);
      });
      patchState(store, {paddockGeometries, area});
    },
    setWeather(weather: WeatherResponse) {
      patchState(store, {weather});
    }
  })
));
